import { ValidationRules } from "aurelia-validation";

export class ContactPhone {
    static clone(o: ContactPhone): ContactPhone {
        var newPhone = Object.assign(new ContactPhone(), o);
        return newPhone;
    }
    contactPhoneId: number;
    contactId: number;
    number: number;
    extension: string;
    type: string;
}


ValidationRules
    .ensure((m: ContactPhone) => m.number).required()
    .ensure((m: ContactPhone) => m.type).required()
    .on(ContactPhone);
